export const NATURAL_LANGUAGE_SEARCH_AI_GLOW_EFFECT_TIME_OUT_MS = 4000

export const MIN_VALID_OFFERS_TO_SHOW_RESULTS = 1
export const MIN_INVALID_OFFERS_TO_SHOW_NO_MATCHES = 3

export const NLS_NO_EXACT_MATCHES_MESSAGE = 'No exact matches, we’ve found related escapes we think you’ll love'
export const NLS_NO_EXACT_MATCHES_MESSAGE_SHORT = 'No exact matches'
